import { render, staticRenderFns } from "./ShoppingLieferungArtikel.vue?vue&type=template&id=b5cfd6c6"
import script from "./ShoppingLieferungArtikel.vue?vue&type=script&lang=ts"
export * from "./ShoppingLieferungArtikel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports